<rappider-title-toolbar [mainTitle]="projectModuleTitle"
                        [options]="projectModuleOptiontitle"
                        [displayToolbar]="displayToolbar"
                        [displayToolbarBackButton]="displayToolbarBackButton">
</rappider-title-toolbar>

<section>
  <rappider-spin [spinning]="isModuleOperationsLoading">
    <rappider-list-wrapper [data]="copiedProjects"
                           [listGridConfig]="listGridConfig"
                           [cardListConfig]="copiedProjectsCardConfig"
                           [listMode]="listMode"
                           [displayToolbar]="true"
                           [displayToolbarBackButton]="false"
                           [titleBarActionButtons]="[addModuleAction]"
                           (titleBarActionButtonClicked)="onAddModuleAction($event)"
                           (itemDeleted)="onCopiedProjectDeleted($event)"
                           (cardListItemActionClicked)="onCardListItemActionClicked($event)"
                           (listGridColumnActionClick)="onListGridColumnActionClick($event)">
    </rappider-list-wrapper>
  </rappider-spin>

  <rappider-modal [(visible)]="projectInformationModalVisibility"
                  [footer]="null"
                  [fullScreen]="true"
                  [closeIconVisibility]="false"
                  (visibleChange)="onProjectInformationModalVisibility($event)">
    <div class="close-button-wrapper">
      <rappider-button class="close-button"
                       [icon]="closeButtonIcon"
                       [size]="closeButtonIcon.size"
                       [customColorSettings]="closeButtonIcon.customColorSettings"
                       [borderSettings]="closeButtonIcon.borderSettings"
                       (click)="onProjectInformationModalVisibility(false)">
      </rappider-button>
    </div>

    <rappider-spin [spinning]="addingModuleLoading">
      <rappider-cards *ngIf="projectInformationModalVisibility"
                      class="project-information-cards-component-wrapper"
                      [items]="cardsConfig?.items"
                      [itemCountPerRow]="cardsConfig.itemCountPerRow!"
                      [showTitleOnImage]="cardsConfig?.showTitleOnImage"
                      [showDescriptionOnImage]="cardsConfig?.showDescriptionOnImage"
                      [selectConfig]="cardsConfig?.selectConfig"
                      [paginationConfig]="cardsConfig?.paginationConfig!"
                      [showCheckMarkOnCard]="cardsConfig?.showCheckMarkOnCard"
                      [isDynamicPagination]="cardsConfig?.isDynamicPagination"
                      [menuConfig]="cardsConfig?.menuConfig"
                      [menuConfigVisible]="cardsConfig?.menuConfigVisible"
                      [buttons]="cardsConfig?.buttons"
                      [selfPreviewMode]="false"
                      [detailedSearchActive]="true"
                      [categoryFilterCollapseVisible]="cardsConfig?.categoryFilterCollapseVisible"
                      [tagFilterCollapseVisible]="cardsConfig?.tagFilterCollapseVisible"
                      (topButtonsClick)="onTopButtonsClick($event)"
                      (imageButtonClick)="onImageButtonClick($event)"
                      (modalConfirm)="onModalConfirm($event)"
                      (additionalButtonClick)="onAdditionalButtonClick($event)">
      </rappider-cards>
    </rappider-spin>
  </rappider-modal>

  <rappider-modal [visible]="previewModalVisibility"
                  [title]="previewModalTitle"
                  [closeIconVisibility]="true"
                  [okText]="previewModalOkText"
                  [cancelText]="previewModalCancelText"
                  [fullScreen]="true"
                  [okLoading]="addingModuleLoading"
                  [okDisabled]="addingModuleLoading"
                  (cancelClick)="modalCancelClick()"
                  (okClick)="modalOkClick()">
    <div class="title-wrapper">
      <rappider-paragraph [content]="selectedTemplatePreview?.name"
                          [typography]="selectedTemplateNameConfig.typography"
                          [colorSettings]="selectedTemplateNameConfig.colorSettings">
      </rappider-paragraph>
    </div>
    <div class="preview-wrapper">
      <div class="preview-title">
        <rappider-paragraph [content]="selectedTemplatePreview?.description"
                            [typography]="selectedTemplateDescriptionConfig.typography"
                            [colorSettings]="selectedTemplateDescriptionConfig.colorSettings">
        </rappider-paragraph>
        <rappider-divider class="rappider-divider"></rappider-divider>
      </div>
      <div class="preview-content-wrapper">
        <div *ngFor="let thumbnail of selectedTemplatePreview?.thumbnails"
             class="preview-content">
          <rappider-image [source]="thumbnail.url"></rappider-image>
          <div class="paragraphs">
            <rappider-paragraph *ngIf="thumbnail.title"
                                [content]="thumbnail.title"
                                [typography]="thumbnailTitleConfig.typography"
                                [colorSettings]="thumbnailTitleConfig.colorSettings">
            </rappider-paragraph>
            <rappider-paragraph *ngIf="thumbnail.description"
                                [content]="thumbnail.description"
                                [typography]="thumbnailDescriptionConfig.typography"
                                [colorSettings]="thumbnailDescriptionConfig.colorSettings">
            </rappider-paragraph>
          </div>
        </div>
      </div>
    </div>
  </rappider-modal>
</section>
